const OPEN_CLASS = 'fc-header__search--is-open';

export function initHeaderSearch(): void {
  document.querySelectorAll<HTMLFormElement>('[data-fc-component="search"]').forEach((form) => {
    const btn = form.querySelector<HTMLButtonElement>('.fc-header__search-btn');
    const input = form.querySelector<HTMLInputElement>('.fc-header__search-input');

    if (!btn || !input) return;

    btn.addEventListener('click', (e) => {
      if (!form.classList.contains(OPEN_CLASS)) {
        // First click: open the input
        e.preventDefault();
        form.classList.add(OPEN_CLASS);
        input.focus();
      }
      // Second click (form open + has value): let the form submit naturally
      // Second click (form open, no value): close
      else if (!input.value.trim()) {
        e.preventDefault();
        form.classList.remove(OPEN_CLASS);
        input.blur();
      }
    });

    // Close on Escape
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        form.classList.remove(OPEN_CLASS);
        input.blur();
      }
    });

    // Close when clicking outside
    document.addEventListener('click', (e) => {
      if (!form.contains(e.target as Node)) {
        form.classList.remove(OPEN_CLASS);
      }
    });
  });
}
